import { useMemo, useState } from "react";
import useSWR from "swr";
import { getFetcher } from "../../../services/api";
import { Button } from "@nextui-org/react";
import IsValidIcon from "../../../components/elements/isValidIcon";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import useListCompany from "../../useListCompany";
import { month } from "../../../enums/month";
import ReportStatusBadge from "../../../components/elements/ReportStatusBadge";
import useCustomNavigate from "../../useCustomNavigate";
import ModalDetailPurchase from "../../../components/fragments/admin/report/purchase/ModalDetailPurchase";
import { useSelectedCompany } from "../../useSelectedCompany";
import useActivePeriodSelection from "../../useActivePeriodSelection";

export default function useTablePurchase() {
  const { editReportPurchase } = useCustomNavigate();
  const [selectedCompany, setSelectedCompany] = useSelectedCompany();
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  /**
   * Periode default = periode aktif TERLAMA yang laporan pembelian-nya belum
   * selesai untuk perusahaan ini. Logikanya ada di hook bersama
   * useActivePeriodSelection, dipakai kelima modul pelaporan dengan
   * resourcePath masing-masing.
   */
  const { selectedPeriod, setSelectedPeriod, dataPeriods, isLoadingPeriods } = useActivePeriodSelection(
    selectedCompany?.value,
    "pelaporan-pembelian",
  );

  const { data, isLoading, mutate } = useSWR(selectedCompany?.value && selectedPeriod?.value ? `/api/pelaporan-pembelian/search?returnAll=true&companyId=${selectedCompany.value}&periodId=${selectedPeriod.value}` : null, getFetcher);

  const { dataCompany, isLoadingCompany } = useListCompany();
  const columnsTableActivePeriod = useMemo(
    () => [
      { field: "id", headerName: "ID", valueGetter: (value, row) => row.bulan },
      { field: "tipePembelian", headerName: "Tipe Pembelian" },
      { field: "perusahaan", headerName: "Perusahaan", valueGetter: (value, row) => row.company.name },
      { field: "jumlahPembelianB3", headerName: "Jumlah Pembelian", valueGetter: (value, row) => `${row.jumlahPembelianB3} KG` },
      { field: "periode", headerName: "Periode", valueGetter: (value, row) => row.period.name },
      { field: "bulan", headerName: "Bulan", valueGetter: (value, row) => month[row.bulan - 1] },
      {
        field: "status",
        headerName: "Status",
        renderCell: (params) => {
          const { status, jumlahPembelianB3, laporanTersedia } = params.row;

          // Logika menentukan status Disimpan
          let computedStatus = status;
          if (!status || status === null) {
            if ((jumlahPembelianB3 && jumlahPembelianB3 !== 0 && laporanTersedia === true) || (jumlahPembelianB3 === 0 && laporanTersedia === false)) {
              computedStatus = "Disimpan";
            }
          }

          return <ReportStatusBadge status={computedStatus} />;
        },
        sortable: false,
        filterable: false,
      },
      {
        field: "isFinalized",
        headerName: "Finalisasi",
        renderCell: (params) => (
          <div className="mt-1">
            <IsValidIcon value={params.row.isFinalized} validMessage="Sudah Finalisasi" invalidMessage="Belum Finalisasi" />
          </div>
        ),
        sortable: false,
        filterable: false,
      },
      {
        field: "action",
        headerName: "Aksi",
        renderCell: (params) => (
          <div className="flex items-center gap-1">
            <ModalDetailPurchase item={params.row} />
            {!params.row.isFinalized && (
              <Button onPress={() => editReportPurchase(params.row.id)} size="sm" color="warning" isIconOnly>
                <PencilSquareIcon className="size-4" />
              </Button>
            )}
          </div>
        ),
        sortable: false,
        filterable: false,
      },
    ],
    [editReportPurchase]
  );

  return {
    dataFetch: {
      data,
      isLoading,
      mutate,
      dataCompany,
      isLoadingCompany,
      dataPeriods,
      isLoadingPeriods,
    },
    state: {
      selectedCompany,
      setSelectedCompany,
      selectedMaterial,
      setSelectedMaterial,
      selectedPeriod,
      setSelectedPeriod,
    },
    columnsTableActivePeriod,
  };
}